import { Link } from 'gatsby'
import React from 'react'
import PropTypes from 'prop-types'
import { GatsbyImage } from "gatsby-plugin-image";

const OrganizationCard = ({ name, logo, slug, loading, className = '' }) => (
  <Link to={slug} title={name} className={className}>
    {logo
      ? (
        <GatsbyImage
          image={logo.gatsbyImageData}
          alt={name}
          title={name}
          loading={loading}
          fadeIn={false}
          className="w-full h-full shadow-sm rounded-full object-cover"
        />
      ) : (
        <span>{name}</span>
      )}
  </Link>
)

OrganizationCard.propTypes = {
  name: PropTypes.string.isRequired,
  logo: PropTypes.object,
  slug: PropTypes.string.isRequired,
  loading: PropTypes.string,
  className: PropTypes.string,
}

export default OrganizationCard
